module.exports = __webpack_public_path__ + "img/network-6.ed260182.jpg";